import { render, staticRenderFns } from "./DR.vue?vue&type=template&id=28fa9924&scoped=true"
import script from "./DR.vue?vue&type=script&lang=js"
export * from "./DR.vue?vue&type=script&lang=js"
import style0 from "./DR.vue?vue&type=style&index=0&id=28fa9924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa9924",
  null
  
)

export default component.exports